import { renderHTMLString } from '../../../../../../../../helpers';
import { StyledWrapper } from './styles';

export interface ProductDescriptionProps {
  description: string;
}

export default function ProductDescription(props: ProductDescriptionProps) {
  const { description } = props;

  return <StyledWrapper>{renderHTMLString(description, false)}</StyledWrapper>;
}
